<template>
  <section id="container" class="complaint-details">
    <div class="banner">
      <h1 class="title">Reclamo N° {{ complaint.refNumber }}</h1>
    </div>

    <div class="card-full-page">
      <section class="section">
        <h2 class="subtitle my-0">Información del cliente</h2>

        <div class="row" v-if="complaint.businessLocation">
          <div class="col-md-6">
            <label for="" class="label">Local de incidencia</label>
            <p class="text">
              {{ complaint.businessLocation.name }}
            </p>
          </div>

          <div class="col-md-6">
            <label for="" class="label">Dirección de local</label>
            <p class="text">
              {{ complaint.businessLocation.address }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="" class="label">Tipo de documento</label>
            <p class="text">
              {{ getIdentifierType(complaint.identifierType).label }}
            </p>
          </div>

          <div class="col-md-6">
            <label for="" class="label">Número de documento</label>
            <p class="text">{{ complaint.identifier }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="" class="label">Nombres</label>
            <p class="text">{{ complaint.firstName }}</p>
          </div>

          <div class="col-md-6">
            <label for="" class="label">Apellidos</label>
            <p class="text">{{ complaint.lastName }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="" class="label">Celular</label>
            <p class="text">{{ complaint.mobile }}</p>
          </div>

          <div class="col-md-6">
            <label for="" class="label">Correo electrónico</label>
            <p class="text">{{ complaint.email }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="" class="label">Dirección</label>
            <p class="text">{{ complaint.address }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="" class="label">Departamento</label>
            <p class="text">{{ complaint.department }}</p>
          </div>

          <div class="col-md-6">
            <label for="" class="label">Provincia</label>
            <p class="text">{{ complaint.province }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="" class="label">Distrito</label>
            <p class="text">{{ complaint.district }}</p>
          </div>
        </div>

        <!-- Menor de edad -->
        <template v-if="complaint.isUnderAge">
          <div class="row">
            <div class="col-12">
              <h2 class="subtitle secondary mb-0 mx-0 px-0">
                Información del apoderado
              </h2>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="" class="label">Tipo de documento</label>
              <p class="text">
                {{ getIdentifierType(complaint.guardianIdentifierType).label }}
              </p>
            </div>

            <div class="col-md-6">
              <label for="" class="label">Número de documento</label>
              <p class="text">{{ complaint.guardianIdentifier }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="" class="label">Nombres</label>
              <p class="text">{{ complaint.guardianFirstName }}</p>
            </div>

            <div class="col-md-6">
              <label for="" class="label">Apellidos</label>
              <p class="text">{{ complaint.guardianLastName }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="" class="label">Celular</label>
              <p class="text">{{ complaint.guardianMobile }}</p>
            </div>

            <div class="col-md-6">
              <label for="" class="label">Correo electrónico</label>
              <p class="text">{{ complaint.guardianEmail }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label for="" class="label">Dirección</label>
              <p class="text">{{ complaint.guardianAddress }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="" class="label">Departamento</label>
              <p class="text">{{ complaint.guardianDepartment }}</p>
            </div>

            <div class="col-md-6">
              <label for="" class="label">Provincia</label>
              <p class="text">{{ complaint.guardianProvince }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="" class="label">Distrito</label>
              <p class="text">{{ complaint.guardianDistrict }}</p>
            </div>
          </div>
        </template>
      </section>

      <section class="section">
        <h2 class="subtitle">Información del bien contratado</h2>

        <div class="row">
          <div class="col-md-6">
            <label for="" class="label">Bien contratado</label>

            <p class="text">
              {{ getWeelType(complaint.wellType).label }}
            </p>
          </div>

          <div class="col-md-6">
            <label for="" class="label">Monto del reclamo en soles</label>

            <p class="text" v-decimal:pen="complaint.wellAmount"></p>
          </div>

          <div class="col-12">
            <label for="" class="label">Descripción</label>

            <div class="text" v-html="complaint.wellDescription">
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <h2 class="subtitle">Información del detalle del reclamo</h2>

        <div class="row">
          <div class="col-12">
            <label for="" class="label">Tipo de reporte</label>

            <p class="text">
              {{ getReportType(complaint.type).label }}
            </p>
          </div>

          <div class="col-12">
            <label for="" class="label">Descripción</label>

            <p class="text">
              {{ complaint.description }}
            </p>
          </div>
        </div>
      </section>

      <section class="section">
        <h2 class="subtitle">Información de archivos adjuntos</h2>

        <div class="row">
          <div class="col-12">
            <label for="" class="label d-block mb-2">Descargar archivos</label>

            <div class="d-flex flex-column align-items-start"
              v-if="complaint.attachments && complaint.attachments.length">
              <a href="" class="attachement" v-for="item in complaint.attachments" :key="item.id"
                @click.prevent="downloadFile(item)">
                <DownloadFileIcon />
                <span class="d-inline-block ml-2">{{ item.name }}</span>
              </a>
            </div>

            <SimpleAlert text="El cliente no adjuntó archivos." class="alert-attachments mt-2" v-else>
              <template v-slot:icon>
                <WarningAlertIcon class="mr-2 alert-icon" />
              </template>
            </SimpleAlert>
          </div>
        </div>
      </section>

      <b-form class="section custom-form" @submit.prevent="openSubmitProcess()">
        <h2 class="subtitle">
          Observaciones y acciones adoptadas por el proveedor
        </h2>

        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mt-4">
              <label for="observations" class="label d-block my-0">{{
                complaint.respondedAt
                  ? "Descripción"
                  : "Ingrese las acciones adaptadas"
              }}</label>

              <div v-if="!complaint.respondedAt">
                <button type="button" class="btn btn-sm btn-light font-weight-bold mr-2" v-b-tooltip.hover
                  title="Revertir cambios" @click="revertAiResponse()" v-if="aiGenerated && draftResponse">
                  <i class="ri-arrow-go-back-line"></i>
                </button>

                <button type="button" :disabled="aiGenerated || form.response.length < 70" class="btn btn-sm btn-outline-primary" v-b-tooltip.hover
                  title="Se habilita después de 70 caracteres"
                  @click="generateAIResponse()">
                  Mejorar con AI
                  <i class="ri-sparkling-line"></i>
                </button>
              </div>
            </div>

            <div class="form-group w-100 mt-2 mb-0" v-if="complaint.status == ComplaintsStatus.PENDING.key">
              <textarea id="observations" placeholder="Escriba aquí"
                class="custom-form-control response-field w-100 mb-0" :class="{ 'response-field-lg': aiGenerated }"
                v-model="form.response"></textarea>
              <FormError v-if="$v.form.response.$error && !$v.form.response.required"
                message="La respuesta es requerida" />
            </div>

            <div v-if="complaint.status == ComplaintsStatus.PENDING.key" class="mt-3">
              <input
                ref="fileInput"
                type="file"
                multiple
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                class="d-none"
                @change="handleFileInput"
              />

              <div
                class="file-drop-zone"
                :class="{ dragging: isDragging }"
                @click="$refs.fileInput.click()"
                @dragover.prevent="isDragging = true"
                @dragleave.prevent="isDragging = false"
                @drop.prevent="handleFileDrop"
              >
                <i class="ri-upload-cloud-2-line file-drop-icon"></i>
                <p class="file-drop-text">Arrastrar archivos aquí o hacer clic para seleccionar</p>
                <p class="file-drop-hint">JPG, PNG, PDF, DOC, DOCX — máx. 5MB por archivo</p>
              </div>

              <p class="file-counter">{{ form.files.length }} de 4 archivos</p>

              <ul class="file-list" v-if="form.files.length > 0">
                <li class="file-list-item" v-for="(file, index) in form.files" :key="index">
                  <i class="ri-file-line"></i>
                  <span class="file-list-item__name" :title="file.name">{{ file.name }}</span>
                  <span class="file-list-item__size">{{ formatFileSize(file.size) }}</span>
                  <button type="button" class="file-list-item__remove" @click="removeFile(index)">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </li>
              </ul>

              <p
                v-for="(error, index) in fileErrors"
                :key="'file-err-' + index"
                class="file-error-message"
              >{{ error }}</p>
            </div>

            <p class="text" v-else>
              {{ complaint.response }}
              <SimpleAlert text="Sin acciones tomadas por el proveedor." class="alert-response mt-2"
                v-if="!complaint.response">
                <template v-slot:icon>
                  <WarningAlertIcon class="mr-2 alert-icon" />
                </template>
              </SimpleAlert>
            </p>
          </div>
        </div>
      </b-form>

      <section class="section border-0 mb-0 pb-0" v-if="complaint.responseAttachments && complaint.responseAttachments.length">
        <h2 class="subtitle">Archivos adjuntos de la respuesta</h2>

        <div class="row">
          <div class="col-12">
            <label class="label d-block mb-2">Descargar archivos adjuntados por la empresa</label>

            <div class="d-flex flex-column align-items-start">
              <a href="" class="attachement" v-for="item in complaint.responseAttachments" :key="item.id"
                @click.prevent="downloadFile(item)">
                <DownloadFileIcon />
                <span class="d-inline-block ml-2">{{ item.name }}</span>
              </a>
            </div>

            <div class="form-group-buttons text-right mb-0 pb-0">
              <button type="button" @click="cancel" class="button button-light mr-1">
                {{
                  complaint.status === ComplaintsStatus.PENDING.key
                    ? "Cancelar"
                    : "Volver"
                }}
              </button>

              <button class="button button-primary" type="submit" v-if="!complaint.respondedAt">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <ConfirmationModal :show="confirmationModal.show" @hide="closeConfirmationModal" :data="confirmationModal"
      @confirm="confirmModal" />
  </section>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

import { requiredIf } from "vuelidate/lib/validators";
import { ComplaintsService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";

import {
  Constants,
  Util,
  DownloadFileIcon,
  ConfirmationModal,
  ConfirmationModalMixin,
  SimpleAlert,
  WarningAlertIcon,
  Alert,
  FormError,
} from "wize-admin";

export default {
  name: "DashboardPage",
  mixins: [ConfirmationModalMixin],
  components: {
    DownloadFileIcon,
    ConfirmationModal,
    SimpleAlert,
    WarningAlertIcon,
    FormError,
  },
  data() {
    return {
      complaint: {},
      ComplaintsStatus: LocalConstants.ComplaintsStatus,
      form: {
        response: '',
        files: []
      },
      fileErrors: [],
      isDragging: false,
      draftResponse: null,
      aiGenerated: false
    };
  },
  created() {
    if (this.$route.params.complaintId)
      this.load(this.$route.params.complaintId);
  },
  validations: {
    form: {
      response: {
        required: requiredIf(function () {
          return this.complaint.type == 2 ? true : false;
        }),
      },
    },
  },
  methods: {
    async generateAIResponse() {
      try {
        this.$store.dispatch("app/loading", true);

        this.draftResponse = this.form.response;

        const response = await ComplaintsService.generateAIResponse({
          // type: this.getReportType(this.complaint.type).label,
          // description: this.complaint.description,
          // email: this.complaint.email,
          // companyName: this.business.name,
          // clientName: this.complaint.firstName + ' ' + this.complaint.lastName
          text: this.form.response
        });
        this.form.response = response.text;
        this.aiGenerated = true
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    revertAiResponse() {
      this.form.response = this.draftResponse;
      this.draftResponse = null
    },
    async load() {
      try {
        this.$store.dispatch("app/loading", true);
        const params = { code: this.$route.params.complaintId };
        const response = await ComplaintsService.get(params);
        this.complaint = { ...response.payload };
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    getIdentifierType(key) {
      return Util.searchValue(key, Constants.IdentifierType);
    },
    getWeelType(key) {
      return Util.searchValue(key, LocalConstants.WellTypeValues);
    },
    getReportType(key) {
      return Util.searchValue(key, LocalConstants.ReportTypeValues);
    },
    confirmModal() {
      this.closeConfirmationModal();
      this.submit();
    },
    openSubmitProcess() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      if (this.complaint.respondedAt) return;
      this.openConfirmationModal({
        title: "Marcar como atendido",
        description:
          "¿Está seguro de marcar como atendido el reclamo?. Esta acción no puede ser revertida.",
        acceptText: "Guardar",
        action: "Cancelar",
      });
    },
    cancel() {
      this.$router.go(-1);
    },
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      try {
        this.$store.dispatch("app/loading", true);
        const params = { code: this.$route.params.complaintId };

        const formData = new FormData();
        formData.append('response', this.form.response || '');
        this.form.files.forEach(file => formData.append('files', file));

        await ComplaintsService.respond(formData, params);

        this.form.files = [];
        this.fileErrors = [];
        this.load();

        this.$smoothScroll({
          scrollTo: document.querySelector("#container"),
          updateHistory: false,
        });

        Alert.success("Se ha realizado la actualización correctamente");

        this.editing = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    addFiles(fileList) {
      const ACCEPTED = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'];
      const MAX_FILES = 4;
      const MAX_SIZE = 5 * 1024 * 1024;

      this.fileErrors = [];
      const incoming = Array.from(fileList);

      if (this.form.files.length + incoming.length > MAX_FILES) {
        this.fileErrors.push('No puedes adjuntar más de 4 archivos en total');
        return;
      }

      incoming.forEach(file => {
        const ext = file.name.split('.').pop().toLowerCase();
        if (!ACCEPTED.includes(ext)) {
          this.fileErrors.push(`El archivo "${file.name}" tiene un formato no permitido (JPG, JPEG, PNG, PDF, DOC, DOCX)`);
          return;
        }
        if (file.size > MAX_SIZE) {
          this.fileErrors.push(`El archivo "${file.name}" supera el límite de 5MB`);
          return;
        }
        this.form.files.push(file);
      });
    },
    handleFileDrop(event) {
      this.isDragging = false;
      this.addFiles(event.dataTransfer.files);
    },
    handleFileInput(event) {
      this.addFiles(event.target.files);
      this.$refs.fileInput.value = '';
    },
    removeFile(index) {
      this.form.files.splice(index, 1);
      this.fileErrors = [];
    },
    formatFileSize(bytes) {
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
    async df(url, filename) {
      const response = await axios.get(url, { responseType: "blob" });
      let headers = response.headers;
      const blob = new Blob([response.data], { type: headers["content-type"] });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    downloadFile(item) {
      this.df(item.url, item.name);
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.complaintId)
        this.load(this.$route.params.complaintId);
    },
  },
  computed: {
    ...mapGetters({
      business: "app/getBusiness",
    })
  },
};
</script>

<style lang="stylus">
@import "../Styles/complaint-details.styl"
</style>
